import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  Chip,
  Button,
  Divider,
  Avatar,
} from '@mui/material';
import {
  LocationOn,
  Hotel,
  EventAvailable,
  AirplanemodeActive,
  Star,
} from '@mui/icons-material';

const PackageCard = ({ package: pkg }) => {
  const navigate = useNavigate();

  // Constantes pour les choix de gamme et leurs couleurs
  const categoryColors = {
    standard_non_shifting: '#4caf50', // vert
    standard_shifting: '#8bc34a', // vert clair
    premium_non_shifting: '#ff9800', // orange
    premium_shifting: '#ffc107', // jaune
    luxury_non_shifting: '#f44336', // rouge
    luxury_shifting: '#e91e63', // rose
  };

  const getCategoryLabel = (category) => {
    switch (category) {
      case 'standard_non_shifting':
        return 'Standard non shifting';
      case 'standard_shifting':
        return 'Standard Shifting';
      case 'premium_non_shifting':
        return 'Premium non shifting';
      case 'premium_shifting':
        return 'Premium Shifting';
      case 'luxury_non_shifting':
        return 'Luxury non shifting';
      case 'luxury_shifting':
        return 'Luxury Shifting';
      default:
        return 'N/A';
    }
  };

  const handleCardClick = () => {
    navigate(`/forfaits/${pkg._id}`);
  };

  return (
    <Card 
      sx={{ 
        height: '100%', 
        display: 'flex', 
        flexDirection: 'column',
        transition: 'transform 0.2s, box-shadow 0.2s',
        '&:hover': {
          transform: 'translateY(-5px)',
          boxShadow: '0 10px 20px rgba(0,0,0,0.1)',
        }
      }}
    >
      {/* Entête avec image et badge de gamme */}
      <Box sx={{ position: 'relative' }}>
        <CardMedia
          component="img"
          height="160"
          image={pkg.image || 'https://via.placeholder.com/400x160?text=Forfait+Hajj'}
          alt={pkg.title}
        />
        <Chip
          label={getCategoryLabel(pkg.category)}
          sx={{
            position: 'absolute',
            top: 10,
            right: 10,
            backgroundColor: categoryColors[pkg.category] || '#757575',
            color: 'white',
            fontWeight: 'bold',
          }}
        />
      </Box>

      <CardContent sx={{ flexGrow: 1, display: 'flex', flexDirection: 'column', p: 2 }}>
        {/* Titre et compagnie */}
        <Box sx={{ mb: 1 }}>
          <Typography variant="h6" component="div" gutterBottom noWrap>
            {pkg.title}
          </Typography>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
            <Avatar 
              src={pkg.company.logo} 
              alt={pkg.company.name}
              sx={{ width: 24, height: 24, mr: 1 }}
            />
            <Typography variant="body2" color="text.secondary">
              {pkg.company.name}
            </Typography>
          </Box>
        </Box>

        <Divider sx={{ mb: 1.5 }} />

        {/* Informations principales */}
        <Box sx={{ mb: 2 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
            <EventAvailable fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="body2">
              {pkg.days} jours
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
            <AirplanemodeActive fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="body2" noWrap>
              Départ de {pkg.departureCity}
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', alignItems: 'center', mb: 0.5 }}>
            <Hotel fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="body2" noWrap>
              {pkg.hotelMecca ? `Hôtel Mecque: Zone ${pkg.hotelMecca.zone}` : 'Hôtel à préciser'}
            </Typography>
          </Box>
          
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <LocationOn fontSize="small" sx={{ mr: 1, color: 'primary.main' }} />
            <Typography variant="body2" noWrap>
              {pkg.minaCamp ? `Camp: ${pkg.minaCamp}` : 'Camp à préciser'}
            </Typography>
          </Box>
        </Box>

        {/* Prix et action */}
        <Box sx={{ mt: 'auto', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="h6" component="div" color="primary.main" fontWeight="bold">
            {pkg.price.toLocaleString()} €
          </Typography>
          
          <Button 
            variant="contained" 
            size="small"
            onClick={handleCardClick}
          >
            Détails
          </Button>
        </Box>
      </CardContent>
    </Card>
  );
};

export default PackageCard;